import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _fillInstanceProperty from "@babel/runtime-corejs3/core-js/instance/fill";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import { MORTGAGE_FREQUENCY } from "@Shared/@Types/application/application-enums";
import { defineComponent, toRefs } from "@vue/composition-api";
import * as FieldComponents from "@Shared/components/sections/index";
import { lowerCase } from "@Shared/@Utils/helpers/text";
import { showToast } from "@Shared/@Utils/constants";
import { newMortgageScenarios, copyFrom, formatMoney, formatRate, formatTerm } from "./scenario-calcs";
import i18n from "@Shared/i18n";
export default defineComponent({
  name: "UserSbScenarioAnalyzer",
  components: _objectSpread({}, FieldComponents),
  props: {
    bean: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const {
      bean
    } = toRefs(props);
    let showAnalyzer = true;
    const saveMS = new Array(bean.value.generatedMS.length);
    _fillInstanceProperty(saveMS).call(saveMS, false);
    function saveScenario(gms) {
      const sl = bean.value.savedScenariosList;
      const sll = sl.length;
      if (sll >= 18) {
        showToast("error", i18n.t("financial-tools.sc_selmaxsaved") + "18" + i18n.t("financial-tools.sc_selmaxsavedb"));
        return false;
      }
      const newgms = copyFrom(newMortgageScenarios(), gms);
      newgms.savedSelected = false;
      newgms.savedScenarioId = sll <= 0 ? 1 : sl[sll - 1].savedScenarioId + 1;
      sl.push(newgms);
      return true;
    }
    function saveScenarios() {
      const beanms = bean.value;
      for (let msi = 0; msi < saveMS.length; msi++) if (saveMS[msi]) if (!saveScenario(beanms.generatedMS[msi])) break;
      localStorage.setItem("calcsSavedScenariosList", _JSON$stringify(bean.value.savedScenariosList));
    }
    return {
      formatMoney,
      formatRate,
      formatTerm,
      MORTGAGE_FREQUENCY,
      lowerCase,
      saveMS,
      showAnalyzer,
      saveScenarios
    };
  }
});